import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";

const TICKS = ["Free case review", "No obligation", "100% confidential"];
const fadeUp = (delay) => ({ initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0 }, transition: { delay, duration: 0.5 } });

const HeroTop = ({ page }) => (
  <div className="lg:col-start-1">
    {page.hero_kicker && (
      <motion.span {...fadeUp(0)} className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.06] px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-200" data-testid="case-hero-kicker">
        <span className="cf-pulse h-2 w-2 rounded-full bg-[var(--cf-accent)]" /> {page.hero_kicker}
      </motion.span>
    )}
    <motion.h1 {...fadeUp(0.08)} className="lp-serif mt-5 text-4xl font-bold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-testid="lp-hero-headline">
      {page.hero_headline}
    </motion.h1>
    {page.hero_headline_accent && (
      <motion.p {...fadeUp(0.16)} className="mt-4 text-lg font-semibold text-[var(--cf-accent)] sm:text-xl">
        {page.hero_headline_accent}
      </motion.p>
    )}
  </div>
);

const HeroBottom = ({ page }) => (
  <div className="lg:col-start-1">
    {page.hero_subheadline && (
      <motion.p {...fadeUp(0.22)} className="max-w-xl text-base leading-relaxed text-slate-300">{page.hero_subheadline}</motion.p>
    )}
    <div className="mt-7 grid max-w-xl grid-cols-3 gap-3">
      {(page.stats || []).slice(0, 3).map((s, i) => (
        <motion.div key={s.label} {...fadeUp(0.3 + i * 0.08)} className="rounded-xl border border-white/10 bg-white/[0.04] p-3" data-testid={`case-hero-stat-${i}`}>
          <div className="lp-serif text-xl font-bold text-white sm:text-2xl">{s.number}</div>
          <div className="mt-1 text-[11px] leading-snug text-slate-400">{s.label}</div>
        </motion.div>
      ))}
    </div>
    <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-300">
      {TICKS.map((t) => (
        <li key={t} className="inline-flex items-center gap-1.5">
          <CheckCircle size={16} weight="fill" className="text-[var(--cf-accent)]" /> {t}
        </li>
      ))}
    </ul>
  </div>
);

export const CaseHero = ({ page, children }) => (
  <section className="relative overflow-hidden" data-testid={`lp-hero-${page.slug}`}>
    {page.hero_image_url && (
      <div className="cf-hero-img absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${page.hero_image_url})` }} aria-hidden="true" />
    )}
    <div className="absolute inset-0 bg-[#0a1929]/80" aria-hidden="true" />
    <div className="cf-glow" aria-hidden="true" />
    <div className="cf-grain" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-6xl gap-8 px-5 py-10 sm:py-14 lg:grid-cols-[1.05fr_0.95fr] lg:grid-rows-[auto_1fr] lg:gap-x-14 lg:py-20">
      <HeroTop page={page} />
      <div id="case-quiz" className="scroll-mt-24 lg:col-start-2 lg:row-span-2 lg:row-start-1">{children}</div>
      <HeroBottom page={page} />
    </div>
  </section>
);
